// extracted by mini-css-extract-plugin
export default {"pageSpinner":"PageSpinner_pageSpinner__IlkGa"};